import React, { Component } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { AppState } from "src/store"
import AxiosConfig from "src/utilities/AxiosConfig"
import DynamicForm from "../DynamicForm/DynamicForm"
import stateMutator from "../Utils/StateMutator"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormTaskTypes from "../Types/DynamicFormTaskTypes"
import snackBar from "src/utilities/snackBar/SnackBar"
import FieldTypes from "../Types/FieldTypes"
import NotificationTypes from "src/utilities/Notifications/Types/NotificationTypes"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import saveSetUp from "../Utils/SaveSetup"
import notificationStore from "src/utilities/Notifications/notificationStore"
import completeFormTaskBoiler from "../Utils/CompleteFormTaskBoiler"
import { Button, Modal, Spinner } from "react-bootstrap"
import paletteEngine from "../Utils/paletteEngine"
import LDSEllipsis from "src/components/common/LDS/LDSEllipsis/LDSEllipsis"
import dayjs from "dayjs"
import "./TaskPrompter.css"

interface Props {
    nags: Array<{ dismissable: boolean, notification: NotificationTypes, timeLeft: number, due: string | null }>
    user: EmployeeDataTypes | any
    palette: Array<DynamicFormPaletteTypes>
}

interface State {
    tasks: Array<DynamicFormTaskTypes>
    taskDex: number
    showDebug: boolean
    working: boolean
    saving: boolean
}

class TaskPrompter extends Component<Props, State> {

    date = new Date();
    timeZoneOffset = -this.date.getTimezoneOffset()

    renderReference = [
        { severity: 1, icon: "dangerous", color: "#dc3545", text: "This task is due, you must complete it before moving on..." },
        { severity: 2, icon: "warning", color: "#ffc107", text: "This task is almost due..." },
        { severity: 3, icon: "task", color: "#ffffff", text: "Please finish this task." },
    ]

    state = {
        tasks: [],
        taskDex: 0,
        showDebug: false,
        working: false,
        saving: false
    }

    componentDidMount() {
        this.getDynamicFormTasks()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    getDynamicFormTasks = () => {
        this.manageState([{ key: "working", value: true }])
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetEmployeeDynamicFormTasks/${this.props.user.userId}/*`, AxiosConfig.configValue("min"))
            .then((res) => {
                const tasks = res.data
                this.manageState([{ key: "tasks", value: tasks }, { key: "working", value: false }])
            }).catch(err => {
                //console.log(err)
                this.manageState([{ key: "working", value: false }])
                snackBar({ text: "Error fetching form task", type: "error", timeout: 3000 })
                notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
            })
    }

    findIncompleteTasks = () => {
        const nags = this.props.nags
        let incompletList = []
        for (let i = 0; i < nags.length; i++) {
            const task: DynamicFormTaskTypes = this.state.tasks.filter((obj: { DynamicFormWorkFlowId: number }) => {
                return obj.DynamicFormWorkFlowId === nags[i].notification.workFlowId
            })[0]
            if (task) {
                incompletList.push({
                    task: task,
                    form: task.DynamicForm,
                    scema: JSON.parse(JSON.stringify(task.DynamicForm.FieldsSchema)),
                    notification: nags[i].notification,
                    dismisable: nags[i].dismissable,
                    timeLeft: nags[i].timeLeft,
                    //@ts-ignore
                    due: dayjs(nags[i].due).utcOffset(notificationStore.timeZoneOffset).format(notificationStore.timeFormat)
                })
            }
        }
        return incompletList.sort(({ timeLeft: a }, { timeLeft: b }) => a - b)
    }

    sumbit = (form: DynamicFormTypes, template: Array<Array<FieldTypes>> | [[]], helper: any) => {
        this.manageState([{ key: "saving", value: true }])
        //@ts-ignore
        const fd = saveSetUp.setUpSave(form, template, this.props.userId, this.props.palette, false)
        let rb = {
            ...{ ...fd },
            ...{ FieldsSchema: form.FieldsSchema },
            ...{ FieldsValues: fd.Fields },
            ...{ EmployeeId: this.props.user.userId },
            ...{ CustomFormDataId: 0 }
        }
        delete rb.Fields
        axios.post(process.env.REACT_APP_API_URL + "/api/Data/SaveDynamicFormData", rb, AxiosConfig.configValue("min"))
            .then((res) => {
                if (typeof (res.data) !== "number") {
                    notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
                    snackBar({ text: "Error saving form task (submit)", type: "error", timeout: 3000 })
                } else {
                    this.saveTask(helper, res.data)
                }
            }).catch((err: any) => {
                //console.log(err)
                this.manageState([{ key: "saving", value: false }])
                notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
                snackBar({ text: "Error saving form task (submit)", type: "error", timeout: 3000 })
            })
    }

    saveTask = (helper: DynamicFormTaskTypes, CustomFormDataId: number,) => {
        const completedTask = completeFormTaskBoiler.generateCompletedTask(helper, this.props.user, CustomFormDataId)
        axios.post(process.env.REACT_APP_API_URL + "/api/company/SaveDynamicFormTask", { tasks: [completedTask] }, AxiosConfig.configValue("min"))
            .then((res) => {
                let errs = 0
                const resp = res.data
                for (let i = 0; i < resp.length; i++) {
                    if (!resp[i].error.success) {
                        errs++
                    }
                }
                if (errs > 0) {
                    snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
                    notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
                } else {
                    snackBar({ text: "Task completed", type: "primary", timeout: 3000 })
                    notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [] } }])//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    notificationStore.getNotifications(this.props.user.userId)
                    this.manageState([{ key: "saving", value: false }])
                }

            }).catch((err: any) => {
                //console.log(err)
                this.manageState([{ key: "saving", value: false }])
                snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
                notificationStore.manageState([{ key: "naggy", value: { shouldNag: false, tasks: [], error: true } }])
            })
    }

    //@ts-ignore
    getUtlis = (severity: number) => {
        const reference = this.renderReference
        for (let i = 0; i < reference.length; i++) {
            if (severity === reference[i].severity) {
                return reference[i]
            }
        }
        return this.getUtlis(3)
    }

    render() {

        const state = this.state
        const props = this.props
        const taskDex = state.taskDex
        const incompleteTasks = this.findIncompleteTasks()
        const viewItem = incompleteTasks[taskDex]
        const severity = viewItem ? (viewItem.timeLeft >= 4320 ? 3 : (viewItem.timeLeft < 4320 && viewItem.timeLeft > -1) ? 2 : 1) : 1
        const status = viewItem ? {
            dismisable: severity > 1,
            timeLeft: viewItem.timeLeft,
            due: viewItem.due,
            utils: this.getUtlis(severity)

        } : {
            dismisable: true,
            timeLeft: 100,
            due: null,
            utils: this.getUtlis(3)
        }

        const backgroundColor = `${paletteEngine.getPaletteColor("formBackgroundColor")}`
        const inputTextColor = `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
        const headerTextColor = `${paletteEngine.getPaletteColor("headerTextColor")}`

        // console.log("TaskPrompter state", state)
        // console.log("TaskPrompter props", props)
        // console.log("TaskPrompter status", status)

        return (
            <div className="TaskPrompter">
                <Modal id="task-prompter-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={"lg"}
                >
                    <Modal.Header style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskPrompterModalHeader">
                            {!state.saving && <div className="TaskPrompterModalHeaderNotSaving">
                                <span style={{ color: status.utils.color }} className="material-icons">{status.utils.icon}</span>
                                <p style={{ color: headerTextColor }}>{status.utils.text}</p>
                            </div>}
                            {state.saving && <div className="TaskPrompterModalHeaderSaving">
                                <Spinner style={{ color: headerTextColor }} animation="border" />
                                <p style={{ color: inputTextColor }}>Saving form data...</p>
                            </div>}
                            {viewItem && <div className="TaskPrompterModalHeaderDebugInfo"
                                onMouseEnter={() => this.manageState([{ key: "showDebug", value: true }])}
                                onMouseLeave={() => this.manageState([{ key: "showDebug", value: false }])}
                            >
                                <p style={{ color: state.showDebug ? inputTextColor : backgroundColor }}>
                                    {`N-${viewItem.notification.id}_W-${viewItem.task.DynamicFormWorkFlowId}`}
                                </p>
                            </div>}
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskPrompterModalBody">
                            {incompleteTasks.length > 0 &&
                                <DynamicForm
                                    form={viewItem.form}
                                    helper={{ ...viewItem.task, ...viewItem.notification }}
                                    addOrRemoveColumn={() => null}
                                    submit={this.sumbit}
                                    palette={props.palette}
                                    notificationToMarkDateRead={viewItem.notification}
                                />}
                            {incompleteTasks.length === 0 && <div className="TaskPrompterModalBodyFindingTasks">
                                <LDSEllipsis />
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskPrompterModalFooter">
                            {status.due && <div className="TaskPrompterModalFooterTimeLeft" style={{ color: inputTextColor }}>
                                <span className="material-icons">schedule</span>
                                <p>{status.due}</p>
                            </div>}
                            <Button disabled={state.working || !status.dismisable} variant="secondary" onClick={() => notificationStore.ignoreNag(viewItem.task.DynamicFormWorkFlowId, props.user.userId)}>Dismiss</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user,
    palette: state.dynamicFormPalette
})

export default connect(mapStateToProps)(TaskPrompter)